import React from "react";
import { connect } from "react-redux";
import "./ImageArrList.css";
import {
  inserImageArrAction,
  saveArticleAction
} from "../../redux/actions/editArticlePanel";
import ImageArrListItem from "../ImageArrListItem/ImageArrListItem";

class ImageArrList extends React.Component {
  constructor(props) {
    super(props);
    this.updateScrollTop = this.updateScrollTop.bind(this);
    this.setCurDragY = this.setCurDragY.bind(this);
    this.insertItem = this.insertItem.bind(this);
    this.scrollTops = [];
    this.curDragY = -1;

    this.panelRefs = {};

    this.state = {
      highlightItemID: null
    };
  }

  updateScrollTop() {
    this.scrollTops = [];

    const { item } = this.props;
    const { imageItemArr } = item;

    for (let i = 0; i < imageItemArr.length; i++) {
      const itemID = imageItemArr[i].id;
      const topBound = this.panelRefs[itemID].current.offsetTop;
      const height = this.panelRefs[itemID].current.clientHeight;

      const positionData = {
        id: itemID,
        topBound: topBound,
        btmBound: topBound + height
      };

      this.scrollTops.push(positionData);
    }
  }

  setCurDragY(y) {
    this.curDragY = y;
    const highlightItemID = getHighlightItem(this.curDragY, this.scrollTops);

    if (highlightItemID !== this.state.highlightItemID) {
      this.setState({ highlightItemID });
      this.updateScrollTop();
    }
  }

  insertItem(fromItemID) {
    const { highlightItemID } = this.state;
    const {
      item,
      inserImageArrAction,
      saveArticleAction,
      articleID
    } = this.props;
    const { imageItemArr } = item;

    if (
      fromItemID != null &&
      highlightItemID != null &&
      fromItemID !== highlightItemID
    ) {
      let fromItemIdx = imageItemArr.findIndex(item => item.id === fromItemID);
      let toItemIdx = imageItemArr.findIndex(
        item => item.id === highlightItemID
      );

      if (fromItemIdx >= 0 && toItemIdx >= 0 && fromItemIdx !== toItemIdx - 1) {
        inserImageArrAction({
          id: item.id,
          fromItemID,
          toItemID: highlightItemID
        });
        saveArticleAction(articleID);
        return true;
      }
    }

    return false;
  }

  render() {
    const { item, getPanelPosition, getCardTop, articleID } = this.props;
    const { imageItemArr } = item;
    const { highlightItemID } = this.state;

    return imageItemArr.map(anImageItem => {
      this.panelRefs[anImageItem.id] = React.createRef();

      return (
        <ImageArrListItem
          key={anImageItem.id}
          setCurDragY={this.setCurDragY}
          updateScrollTop={this.updateScrollTop}
          getPanelPosition={getPanelPosition}
          getCardTop={getCardTop}
          itemID={item.id}
          isHighlight={highlightItemID === anImageItem.id}
          insertItem={this.insertItem}
          forwardRef={this.panelRefs[anImageItem.id]}
          imageItem={anImageItem}
          articleID={articleID}
        />
      );
    });
  }
}

function getHighlightItem(curDragY, scrollTops) {
  const highlightArr = scrollTops.filter(aPositionData => {
    if (aPositionData == null) {
      return false;
    }

    return (
      aPositionData.topBound <= curDragY && curDragY <= aPositionData.btmBound
    );
  });

  let highlightItemID = null;

  if (highlightArr.length > 0) {
    highlightItemID = highlightArr[0].id;
  }

  return highlightItemID;
}

const mapDispatch = {
  inserImageArrAction,
  saveArticleAction
};

export default connect(
  null,
  mapDispatch
)(ImageArrList);
